export const PRIVACY_POLICY_CONTENT = {
  es: {
    pageTitle: "Política de Privacidad – Cyrqle",
    metaDescription:
      "Política de privacidad de Cyrqle: datos del círculo familiar, requisitos de edad, consentimiento y derechos del titular de la cuenta.",
    lastUpdated: "Última actualización: junio 2026",
    back: "Volver al inicio",
    intro:
      "Cyrqle es una aplicación familiar de bienestar que respeta tu privacidad y la de tu círculo cercano. Esta política explica qué datos recopilamos, cómo los utilizamos, qué requisitos de edad y consentimiento aplican, y qué derechos tienes como titular de la cuenta.",
    contactEmail: "privacy@sentinelzone.com",
    sections: [
      {
        title: "1. Información que recopilamos",
        paragraphs: ["Cyrqle puede recopilar los siguientes tipos de información:"],
        subsections: [
          {
            title: "a) Información proporcionada por el usuario",
            items: [
              "Datos de salud del titular de la cuenta y de miembros de su círculo familiar (biomarcadores, análisis de laboratorio, informes importados)",
              "Información de perfil básica del titular y, cuando corresponda, identificación de los miembros del círculo a los que se refieren los datos",
              "Declaraciones de edad, titularidad y consentimiento que el titular confirma al subir datos de terceros",
            ],
          },
          {
            title: "b) Datos generados por el uso de la app",
            items: [
              "Historial de interacción con la aplicación",
              "Tendencias derivadas de los datos de salud introducidos",
            ],
          },
          {
            title: "c) Datos técnicos",
            items: [
              "Información del dispositivo (modelo, sistema operativo)",
              "Identificadores anónimos para mejorar estabilidad y rendimiento",
            ],
          },
        ],
      },
      {
        title: "2. Edad, titularidad y consentimiento",
        paragraphs: [
          "Cyrqle está diseñada para que un adulto responsable centralice y comprenda datos de salud de su círculo familiar.",
          "Solo las personas mayores de 18 años pueden crear una cuenta y subir datos de salud a la aplicación.",
        ],
        listItems: [
          "El titular de la cuenta declara tener al menos 18 años y ser quien opera la app.",
          "Los datos de menores de edad del círculo solo pueden introducirse por quien ostente legitimación parental, tutela o representación legal.",
          "Los datos de adultos mayores de 18 años del círculo requieren su consentimiento previo, explícito e informado antes de ser subidos.",
          "Si introduces datos de adultos sin consentimiento válido, o no puedes acreditarlo cuando te lo solicitemos, podemos restringir el acceso a tu cuenta, limitar funciones o solicitar la eliminación de esos datos.",
        ],
      },
      {
        title: "3. Uso de la información",
        paragraphs: ["Utilizamos la información recopilada para:"],
        listItems: [
          "Mostrar y organizar los datos de salud del titular y de su círculo familiar",
          "Generar insights y tendencias de bienestar personalizadas para el cuidado de tu familia",
          "Responder tus preguntas a través del asistente de inteligencia artificial Andy",
          "Mejorar la funcionalidad de la aplicación",
          "Garantizar el correcto funcionamiento del sistema y el cumplimiento de requisitos de consentimiento",
        ],
        closing: ["Cyrqle no utiliza tus datos para publicidad."],
      },
      {
        title: "4. No es un servicio médico",
        paragraphs: [
          "Cyrqle es una aplicación de bienestar e interpretación de datos de salud.",
        ],
        listItems: [
          "No proporciona diagnósticos médicos",
          "No ofrece tratamientos",
          "No sustituye la opinión de profesionales sanitarios",
        ],
        closing: [
          "Las decisiones sobre salud de cualquier miembro del círculo deben validarse siempre con su profesional sanitario.",
        ],
      },
      {
        title: "5. Compartición de datos",
        paragraphs: [
          "No vendemos tus datos personales.",
          "Solo compartimos información en los siguientes casos:",
        ],
        listItems: [
          "Proveedores tecnológicos necesarios para el funcionamiento de la app",
          "Cloudflare Workers AI, proveedor de la tecnología de inteligencia artificial utilizada por el asistente Andy",
          "Cumplimiento de obligaciones legales",
          "Servicios de análisis y rendimiento (de forma agregada o anonimizada cuando sea posible)",
        ],
      },
      {
        title: "6. Servicios de inteligencia artificial (Andy)",
        paragraphs: [
          "Cyrqle incluye a Andy, un asistente de inteligencia artificial que te ayuda a interpretar tus datos de salud y los de tu círculo familiar.",
          "Para generar respuestas, estos datos se envían a Cloudflare Workers AI, proveedor de la tecnología de inteligencia artificial utilizada por Cyrqle, a través de nuestro servicio Andy (andy.sentinelzone.com).",
          "Antes de compartir estos datos, la aplicación te informa y solicita tu consentimiento explícito. Puedes retirar este consentimiento en cualquier momento desde los ajustes de la app.",
        ],
        subsections: [
          {
            title: "Datos que se envían al servicio de IA",
            items: [
              "Biomarcadores y resultados de análisis del titular y de los miembros del círculo que gestionas.",
              "Contexto de salud de la pantalla sobre la que preguntas: por ejemplo, el biomarcador consultado (nombre, valor, unidad, rango de referencia y estado) o la métrica de bienestar consultada.",
              "Los mensajes que escribes en la conversación con Andy.",
              "Tu identificador de cuenta.",
            ],
          },
          {
            title: "Proveedor de inteligencia artificial",
            items: [
              "Cloudflare Workers AI (Cloudflare, Inc.), que procesa los datos en nombre de Cyrqle únicamente para generar las respuestas del asistente.",
            ],
          },
        ],
        closing: [
          "Estos datos se utilizan exclusivamente para generar respuestas personalizadas a tus preguntas y no se utilizan con fines publicitarios. Cloudflare Workers AI está obligado a aplicar un nivel de protección equivalente al descrito en esta política.",
        ],
      },
      {
        title: "7. Seguridad",
        paragraphs: [
          "Aplicamos medidas técnicas y organizativas para proteger tu información contra accesos no autorizados, pérdida o alteración.",
        ],
      },
      {
        title: "8. Retención de datos",
        paragraphs: [
          "Los datos se conservan mientras la cuenta esté activa o mientras sea necesario para prestar el servicio. El usuario puede solicitar la eliminación de sus datos en cualquier momento.",
        ],
      },
      {
        title: "9. Derechos del usuario",
        paragraphs: ["Dependiendo de tu jurisdicción, puedes tener derecho a:"],
        listItems: [
          "Acceder a tus datos",
          "Rectificar información incorrecta",
          "Solicitar la eliminación de datos",
          "Limitar el procesamiento de datos",
        ],
      },
      {
        title: "10. Cambios en esta política",
        paragraphs: [
          "Podemos actualizar esta política ocasionalmente. Notificaremos cambios importantes dentro de la aplicación o en esta misma página.",
        ],
      },
      {
        title: "11. Contacto",
        paragraphs: ["Si tienes preguntas sobre esta política, puedes contactarnos en:"],
        contact: true,
      },
    ],
  },
  en: {
    pageTitle: "Privacy Policy – Cyrqle",
    metaDescription:
      "Cyrqle privacy policy: family circle data, age requirements, consent, and account holder rights.",
    lastUpdated: "Last updated: June 2026",
    back: "Back to home",
    intro:
      "Cyrqle is a family wellness application that respects your privacy and that of your close circle. This policy explains what data we collect, how we use it, what age and consent requirements apply, and what rights you have as the account holder.",
    contactEmail: "privacy@sentinelzone.com",
    sections: [
      {
        title: "1. Information we collect",
        paragraphs: ["Cyrqle may collect the following types of information:"],
        subsections: [
          {
            title: "a) Information provided by the user",
            items: [
              "Health data of the account holder and members of their family circle (biomarkers, lab results, imported reports)",
              "Basic profile information of the holder and, where applicable, identification of circle members the data refers to",
              "Age, ownership, and consent declarations the holder confirms when uploading third-party data",
            ],
          },
          {
            title: "b) Data generated by app usage",
            items: [
              "History of interactions with the application",
              "Trends derived from the health data entered",
            ],
          },
          {
            title: "c) Technical data",
            items: [
              "Device information (model, operating system)",
              "Anonymous identifiers to improve stability and performance",
            ],
          },
        ],
      },
      {
        title: "2. Age, ownership, and consent",
        paragraphs: [
          "Cyrqle is designed for a responsible adult to centralize and understand health data for their family circle.",
          "Only people aged 18 or over may create an account and upload health data to the application.",
        ],
        listItems: [
          "The account holder declares they are at least 18 years old and the person operating the app.",
          "Data of minors in the circle may only be entered by someone with parental authority, guardianship, or legal representation.",
          "Data of adults aged 18 or over in the circle requires their prior, explicit, and informed consent before being uploaded.",
          "If you upload adult data without valid consent, or cannot prove it when we request it, we may restrict account access, limit features, or require deletion of that data.",
        ],
      },
      {
        title: "3. Use of information",
        paragraphs: ["We use the information collected to:"],
        listItems: [
          "Display and organize health data of the holder and their family circle",
          "Generate personalized wellness insights and trends for family care",
          "Answer your questions through the Andy artificial intelligence assistant",
          "Improve application functionality",
          "Ensure the system works correctly and consent requirements are met",
        ],
        closing: ["Cyrqle does not use your data for advertising."],
      },
      {
        title: "4. Not a medical service",
        paragraphs: [
          "Cyrqle is a wellness and health data interpretation application.",
        ],
        listItems: [
          "It does not provide medical diagnoses",
          "It does not offer treatments",
          "It does not replace the opinion of healthcare professionals",
        ],
        closing: [
          "Health decisions for any circle member should always be validated with their healthcare professional.",
        ],
      },
      {
        title: "5. Data sharing",
        paragraphs: [
          "We do not sell your personal data.",
          "We only share information in the following cases:",
        ],
        listItems: [
          "Technology providers necessary for the app to function",
          "Cloudflare Workers AI, provider of the artificial intelligence technology used by the Andy assistant",
          "Compliance with legal obligations",
          "Analytics and performance services (in aggregated or anonymized form when possible)",
        ],
      },
      {
        title: "6. Artificial intelligence services (Andy)",
        paragraphs: [
          "Cyrqle includes Andy, an artificial intelligence assistant that helps you interpret your health data and your family circle's data.",
          "To generate answers, this data is sent to Cloudflare Workers AI, the provider of the artificial intelligence technology used by Cyrqle, through our Andy service (andy.sentinelzone.com).",
          "Before sharing this data, the app informs you and asks for your explicit consent. You can withdraw this consent at any time in the app settings.",
        ],
        subsections: [
          {
            title: "Data sent to the AI service",
            items: [
              "Biomarkers and lab results of the account holder and circle members you manage.",
              "Health context from the screen you ask about: for example, the biomarker consulted (name, value, unit, reference range, and status) or the wellness metric consulted.",
              "The messages you write in your conversation with Andy.",
              "Your account identifier.",
            ],
          },
          {
            title: "Artificial intelligence provider",
            items: [
              "Cloudflare Workers AI (Cloudflare, Inc.), which processes the data on Cyrqle's behalf solely to generate the assistant's answers.",
            ],
          },
        ],
        closing: [
          "This data is used solely to generate personalized answers to your questions and is not used for advertising. Cloudflare Workers AI is required to apply a level of protection equivalent to the one described in this policy.",
        ],
      },
      {
        title: "7. Security",
        paragraphs: [
          "We apply technical and organizational measures to protect your information against unauthorized access, loss, or alteration.",
        ],
      },
      {
        title: "8. Data retention",
        paragraphs: [
          "Data is retained while the account is active or as long as necessary to provide the service. Users may request deletion of their data at any time.",
        ],
      },
      {
        title: "9. User rights",
        paragraphs: ["Depending on your jurisdiction, you may have the right to:"],
        listItems: [
          "Access your data",
          "Rectify incorrect information",
          "Request deletion of data",
          "Limit data processing",
        ],
      },
      {
        title: "10. Changes to this policy",
        paragraphs: [
          "We may update this policy occasionally. We will notify you of significant changes within the app or on this page.",
        ],
      },
      {
        title: "11. Contact",
        paragraphs: ["If you have questions about this policy, you can contact us at:"],
        contact: true,
      },
    ],
  },
  fr: {
    pageTitle: "Politique de confidentialité – Cyrqle",
    metaDescription:
      "Politique de confidentialité Cyrqle : données du cercle familial, âge, consentement et droits du titulaire du compte.",
    lastUpdated: "Dernière mise à jour : juin 2026",
    back: "Retour à l'accueil",
    intro:
      "Cyrqle est une application familiale de bien-être qui respecte votre vie privée et celle de votre cercle proche. Cette politique explique quelles données nous collectons, comment nous les utilisons, quelles exigences d'âge et de consentement s'appliquent, et quels droits vous avez en tant que titulaire du compte.",
    contactEmail: "privacy@sentinelzone.com",
    sections: [
      {
        title: "1. Informations collectées",
        paragraphs: ["Cyrqle peut collecter les types d'informations suivants :"],
        subsections: [
          {
            title: "a) Informations fournies par l'utilisateur",
            items: [
              "Données de santé du titulaire du compte et des membres de son cercle familial (biomarqueurs, analyses de laboratoire, rapports importés)",
              "Informations de profil de base du titulaire et, le cas échéant, identification des membres du cercle concernés",
              "Déclarations d'âge, de titularité et de consentement confirmées par le titulaire lors du téléversement de données tierces",
            ],
          },
          {
            title: "b) Données générées par l'utilisation de l'app",
            items: [
              "Historique d'interaction avec l'application",
              "Tendances dérivées des données de santé saisies",
            ],
          },
          {
            title: "c) Données techniques",
            items: [
              "Informations sur l'appareil (modèle, système d'exploitation)",
              "Identifiants anonymes pour améliorer la stabilité et les performances",
            ],
          },
        ],
      },
      {
        title: "2. Âge, titularité et consentement",
        paragraphs: [
          "Cyrqle est conçue pour qu'un adulte responsable centralise et comprenne les données de santé de son cercle familial.",
          "Seules les personnes âgées de 18 ans ou plus peuvent créer un compte et téléverser des données de santé dans l'application.",
        ],
        listItems: [
          "Le titulaire du compte déclare avoir au moins 18 ans et être la personne qui utilise l'app.",
          "Les données des mineurs du cercle ne peuvent être saisies que par une personne disposant de l'autorité parentale, de la tutelle ou d'une représentation légale.",
          "Les données des adultes de 18 ans ou plus du cercle nécessitent leur consentement préalable, explicite et éclairé avant téléversement.",
          "Si vous téléversez des données d'adultes sans consentement valide, ou ne pouvez pas le justifier sur demande, nous pouvons restreindre l'accès au compte, limiter des fonctionnalités ou exiger la suppression de ces données.",
        ],
      },
      {
        title: "3. Utilisation des informations",
        paragraphs: ["Nous utilisons les informations collectées pour :"],
        listItems: [
          "Afficher et organiser les données de santé du titulaire et de son cercle familial",
          "Générer des insights et tendances de bien-être personnalisés pour le soin de la famille",
          "Répondre à vos questions via l'assistant d'intelligence artificielle Andy",
          "Améliorer les fonctionnalités de l'application",
          "Assurer le bon fonctionnement du système et le respect des exigences de consentement",
        ],
        closing: ["Cyrqle n'utilise pas vos données à des fins publicitaires."],
      },
      {
        title: "4. Ce n'est pas un service médical",
        paragraphs: [
          "Cyrqle est une application de bien-être et d'interprétation de données de santé.",
        ],
        listItems: [
          "Elle ne fournit pas de diagnostics médicaux",
          "Elle n'offre pas de traitements",
          "Elle ne remplace pas l'avis de professionnels de santé",
        ],
        closing: [
          "Les décisions de santé de tout membre du cercle doivent toujours être validées avec son professionnel de santé.",
        ],
      },
      {
        title: "5. Partage des données",
        paragraphs: [
          "Nous ne vendons pas vos données personnelles.",
          "Nous ne partageons des informations que dans les cas suivants :",
        ],
        listItems: [
          "Prestataires technologiques nécessaires au fonctionnement de l'app",
          "Cloudflare Workers AI, fournisseur de la technologie d'intelligence artificielle utilisée par l'assistant Andy",
          "Respect des obligations légales",
          "Services d'analyse et de performance (de manière agrégée ou anonymisée lorsque possible)",
        ],
      },
      {
        title: "6. Services d'intelligence artificielle (Andy)",
        paragraphs: [
          "Cyrqle inclut Andy, un assistant d'intelligence artificielle qui vous aide à interpréter vos données de santé et celles de votre cercle familial.",
          "Pour générer des réponses, ces données sont envoyées à Cloudflare Workers AI, fournisseur de la technologie d'intelligence artificielle utilisée par Cyrqle, via notre service Andy (andy.sentinelzone.com).",
          "Avant de partager ces données, l'application vous informe et demande votre consentement explicite. Vous pouvez retirer ce consentement à tout moment dans les paramètres de l'app.",
        ],
        subsections: [
          {
            title: "Données envoyées au service d'IA",
            items: [
              "Biomarqueurs et résultats d'analyses du titulaire et des membres du cercle que vous gérez.",
              "Contexte de santé de l'écran consulté : par exemple, le biomarqueur consulté (nom, valeur, unité, plage de référence et statut) ou la métrique de bien-être consultée.",
              "Les messages que vous écrivez dans votre conversation avec Andy.",
              "Votre identifiant de compte.",
            ],
          },
          {
            title: "Fournisseur d'intelligence artificielle",
            items: [
              "Cloudflare Workers AI (Cloudflare, Inc.), qui traite les données pour le compte de Cyrqle uniquement afin de générer les réponses de l'assistant.",
            ],
          },
        ],
        closing: [
          "Ces données sont utilisées exclusivement pour générer des réponses personnalisées à vos questions et ne sont pas utilisées à des fins publicitaires. Cloudflare Workers AI est tenu d'appliquer un niveau de protection équivalent à celui décrit dans cette politique.",
        ],
      },
      {
        title: "7. Sécurité",
        paragraphs: [
          "Nous appliquons des mesures techniques et organisationnelles pour protéger vos informations contre les accès non autorisés, la perte ou l'altération.",
        ],
      },
      {
        title: "8. Conservation des données",
        paragraphs: [
          "Les données sont conservées tant que le compte est actif ou aussi longtemps que nécessaire pour fournir le service. L'utilisateur peut demander la suppression de ses données à tout moment.",
        ],
      },
      {
        title: "9. Droits de l'utilisateur",
        paragraphs: ["Selon votre juridiction, vous pouvez avoir le droit de :"],
        listItems: [
          "Accéder à vos données",
          "Rectifier des informations incorrectes",
          "Demander la suppression des données",
          "Limiter le traitement des données",
        ],
      },
      {
        title: "10. Modifications de cette politique",
        paragraphs: [
          "Nous pouvons mettre à jour cette politique occasionnellement. Nous vous informerons des changements importants dans l'application ou sur cette page.",
        ],
      },
      {
        title: "11. Contact",
        paragraphs: ["Si vous avez des questions sur cette politique, contactez-nous à :"],
        contact: true,
      },
    ],
  },
  ca: {
    pageTitle: "Política de privacitat – Cyrqle",
    metaDescription:
      "Política de privacitat de Cyrqle: dades del cercle familiar, edat, consentiment i drets del titular del compte.",
    lastUpdated: "Darrera actualització: juny 2026",
    back: "Tornar a l'inici",
    intro:
      "Cyrqle és una aplicació familiar de benestar que respecta la teva privacitat i la del teu cercle proper. Aquesta política explica quines dades recopilem, com les utilitzem, quins requisits d'edat i consentiment s'apliquen, i quins drets tens com a titular del compte.",
    contactEmail: "privacy@sentinelzone.com",
    sections: [
      {
        title: "1. Informació que recopilem",
        paragraphs: ["Cyrqle pot recopilar els següents tipus d'informació:"],
        subsections: [
          {
            title: "a) Informació proporcionada per l'usuari",
            items: [
              "Dades de salut del titular del compte i dels membres del seu cercle familiar (biomarcadors, anàlisis de laboratori, informes importats)",
              "Informació de perfil bàsica del titular i, quan correspongui, identificació dels membres del cercle als quals es refereixen les dades",
              "Declaracions d'edat, titularitat i consentiment que el titular confirma en pujar dades de tercers",
            ],
          },
          {
            title: "b) Dades generades per l'ús de l'app",
            items: [
              "Historial d'interacció amb l'aplicació",
              "Tendències derivades de les dades de salut introduïdes",
            ],
          },
          {
            title: "c) Dades tècniques",
            items: [
              "Informació del dispositiu (model, sistema operatiu)",
              "Identificadors anònims per millorar l'estabilitat i el rendiment",
            ],
          },
        ],
      },
      {
        title: "2. Edat, titularitat i consentiment",
        paragraphs: [
          "Cyrqle està dissenyada perquè un adult responsable centralitzi i comprengui dades de salut del seu cercle familiar.",
          "Només les persones majors de 18 anys poden crear un compte i pujar dades de salut a l'aplicació.",
        ],
        listItems: [
          "El titular del compte declara tenir almenys 18 anys i ser qui opera l'app.",
          "Les dades de menors d'edat del cercle només poden introduir-se per qui ostenti legitimació parental, tutela o representació legal.",
          "Les dades d'adults majors de 18 anys del cercle requereixen el seu consentiment previ, explícit i informat abans de ser pujades.",
          "Si introdueixes dades d'adults sense consentiment vàlid, o no el pots acreditar quan t'ho sol·licitem, podem restringir l'accés al teu compte, limitar funcions o sol·licitar l'eliminació d'aquestes dades.",
        ],
      },
      {
        title: "3. Ús de la informació",
        paragraphs: ["Utilitzem la informació recopilada per a:"],
        listItems: [
          "Mostrar i organitzar les dades de salut del titular i del seu cercle familiar",
          "Generar insights i tendències de benestar personalitzades per al cuidat de la família",
          "Respondre les teves preguntes a través de l'assistent d'intel·ligència artificial Andy",
          "Millorar la funcionalitat de l'aplicació",
          "Garantir el correcte funcionament del sistema i el compliment dels requisits de consentiment",
        ],
        closing: ["Cyrqle no utilitza les teves dades per a publicitat."],
      },
      {
        title: "4. No és un servei mèdic",
        paragraphs: [
          "Cyrqle és una aplicació de benestar i interpretació de dades de salut.",
        ],
        listItems: [
          "No proporciona diagnòstics mèdics",
          "No ofereix tractaments",
          "No substitueix l'opinió de professionals sanitaris",
        ],
        closing: [
          "Les decisions sobre salut de qualsevol membre del cercle s'han de validar sempre amb el seu professional sanitari.",
        ],
      },
      {
        title: "5. Compartició de dades",
        paragraphs: [
          "No venem les teves dades personals.",
          "Només compartim informació en els casos següents:",
        ],
        listItems: [
          "Proveïdors tecnològics necessaris per al funcionament de l'app",
          "Cloudflare Workers AI, proveïdor de la tecnologia d'intel·ligència artificial utilitzada per l'assistent Andy",
          "Compliment d'obligacions legals",
          "Serveis d'anàlisi i rendiment (de forma agregada o anonimitzada quan sigui possible)",
        ],
      },
      {
        title: "6. Serveis d'intel·ligència artificial (Andy)",
        paragraphs: [
          "Cyrqle inclou l'Andy, un assistent d'intel·ligència artificial que t'ajuda a interpretar les teves dades de salut i les del teu cercle familiar.",
          "Per generar respostes, aquestes dades s'envien a Cloudflare Workers AI, proveïdor de la tecnologia d'intel·ligència artificial utilitzada per Cyrqle, a través del nostre servei Andy (andy.sentinelzone.com).",
          "Abans de compartir aquestes dades, l'aplicació t'informa i et demana el consentiment explícit. Pots retirar aquest consentiment en qualsevol moment des dels ajustos de l'app.",
        ],
        subsections: [
          {
            title: "Dades que s'envien al servei d'IA",
            items: [
              "Biomarcadors i resultats d'anàlisis del titular i dels membres del cercle que gestiones.",
              "Context de salut de la pantalla consultada: per exemple, el biomarcador consultat (nom, valor, unitat, rang de referència i estat) o la mètrica de benestar consultada.",
              "Els missatges que escrius a la conversa amb l'Andy.",
              "El teu identificador de compte.",
            ],
          },
          {
            title: "Proveïdor d'intel·ligència artificial",
            items: [
              "Cloudflare Workers AI (Cloudflare, Inc.), que processa les dades en nom de Cyrqle únicament per generar les respostes de l'assistent.",
            ],
          },
        ],
        closing: [
          "Aquestes dades s'utilitzen exclusivament per generar respostes personalitzades a les teves preguntes i no s'utilitzen amb finalitats publicitàries. Cloudflare Workers AI està obligat a aplicar un nivell de protecció equivalent al descrit en aquesta política.",
        ],
      },
      {
        title: "7. Seguretat",
        paragraphs: [
          "Apliquem mesures tècniques i organitzatives per protegir la teva informació contra accessos no autoritzats, pèrdua o alteració.",
        ],
      },
      {
        title: "8. Retenció de dades",
        paragraphs: [
          "Les dades es conserven mentre el compte estigui actiu o mentre sigui necessari per prestar el servei. L'usuari pot sol·licitar l'eliminació de les seves dades en qualsevol moment.",
        ],
      },
      {
        title: "9. Drets de l'usuari",
        paragraphs: ["Depenent de la teva jurisdicció, pots tenir dret a:"],
        listItems: [
          "Accedir a les teves dades",
          "Rectificar informació incorrecta",
          "Sol·licitar l'eliminació de dades",
          "Limitar el processament de dades",
        ],
      },
      {
        title: "10. Canvis en aquesta política",
        paragraphs: [
          "Podem actualitzar aquesta política ocasionalment. Notificarem canvis importants dins de l'aplicació o en aquesta mateixa pàgina.",
        ],
      },
      {
        title: "11. Contacte",
        paragraphs: ["Si tens preguntes sobre aquesta política, pots contactar-nos a:"],
        contact: true,
      },
    ],
  },
};
